var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdobeelustrator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 197,
    viewBox: "0 0 197 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 197,
    height: 197,
    rx: 20,
    fill: "#404040"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.1866 38.8643H138.192C150.17 38.8643 159.854 48.5486 159.854 60.527V136.474C159.854 148.452 150.17 158.136 138.191 158.136H59.1866C47.2083 158.136 37.5239 148.452 37.5239 136.473V60.527C37.5239 48.5486 47.2083 38.8643 59.1866 38.8643Z",
    fill: "#390000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8032 110.429H77.8421L73.9684 122.407C73.8663 122.866 73.4587 123.172 73 123.121H63.4174C62.8566 123.121 62.7037 122.815 62.8566 122.203L79.2692 74.9534C79.4221 74.4438 79.575 73.8831 79.7788 73.2714C79.9826 72.201 80.0846 71.0797 80.0846 69.9582C80.0337 69.7033 80.2375 69.4486 80.4925 69.3975H80.6454H93.6938C94.1017 69.3975 94.3055 69.5504 94.3564 69.8053L112.961 122.305C113.114 122.866 112.961 123.121 112.451 123.121H101.798C101.442 123.172 101.085 122.917 100.983 122.56L96.8032 110.429ZM80.7983 100.082H93.745L87.2206 78.8272L80.7983 100.082Z",
    fill: "#FF9A00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.073 78.1133C122.391 78.1642 120.759 77.5017 119.536 76.3293C118.364 75.0551 117.752 73.3731 117.803 71.6399C117.752 69.907 118.415 68.2758 119.638 67.1034C120.862 65.931 122.493 65.3193 124.175 65.3193C126.163 65.3193 127.692 65.931 128.813 67.1034C129.934 68.3267 130.546 69.9578 130.495 71.6399C130.546 73.3728 129.934 75.0549 128.711 76.3293C127.539 77.5526 125.806 78.2151 124.073 78.1133Z",
    fill: "#FF9A00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.365 122.357V83.1092C118.365 82.5996 118.569 82.3955 119.027 82.3955H129.12C129.578 82.3955 129.782 82.6504 129.782 83.1092V122.357C129.782 122.918 129.578 123.172 129.12 123.172H119.129C118.619 123.172 118.365 122.866 118.365 122.357Z",
    fill: "#FF9A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdobeelustrator);
export default __webpack_public_path__ + "static/media/adobe elustrator.b2b540b36d715c834964757013e2d582.svg";
export { ForwardRef as ReactComponent };